import React from 'react';

import { Box, Code, Flex, Text } from '@chakra-ui/react';

import { ApiFieldValues } from './ApiFieldValues';
import { ApiParameter } from './types';
import { schemaTypeLabel, unwrapSchema } from './utils';

/** Path and query parameters with type, location and allowed values. */
export const ApiParametersTable = ({
  parameters,
}: {
  parameters: ApiParameter[];
}) => (
  <Box border="1px solid" borderColor="gray.200" borderRadius="md">
    {parameters.map((parameter, index) => {
      const schema = unwrapSchema(parameter.schema);
      const description = parameter.description ?? schema.description;
      return (
        <Box
          key={`${parameter.in}:${parameter.name}`}
          px={4}
          py={2.5}
          borderTop={index ? '1px solid' : undefined}
          borderColor="gray.100"
        >
          <Flex gap={2} align="baseline" wrap="wrap">
            <Code fontSize="13px" bg="transparent" p={0} fontWeight={600}>
              {parameter.name}
            </Code>
            <Text fontSize="13px" color="gray.500">
              {schemaTypeLabel(parameter.schema)}
            </Text>
            <Text fontSize="12px" color="gray.400">
              {parameter.in}
            </Text>
            {parameter.required && (
              <Text fontSize="12px" color="red.500">
                required
              </Text>
            )}
          </Flex>
          {description && (
            <Text fontSize="14px" color="gray.700" mt={0.5}>
              {description}
            </Text>
          )}
          {schema.enum && <ApiFieldValues values={schema.enum.map(String)} />}
        </Box>
      );
    })}
  </Box>
);
